import gql from 'graphql-tag';

import { executeGqlQuery } from 'src/graphql/client';
import type { ID } from 'src/lib/collection';
import { getSingleProp } from 'src/lib/graphql';
import type { BackendAuthorCompleteTrace } from 'src/types/backend';

const QUERY = gql`
  query AuthorCompleteTrace($id: ID!) {
    authorCompleteTrace(id: $id) {
      id
      acMachineName
      spans {
        id
        name
        data
        response
      }
    }
  }
`;

type Result = BackendAuthorCompleteTrace;

export const queryAuthorCompleteTrace = async (id: ID): Promise<Result | undefined> => {
  const result = await executeGqlQuery({
    query: QUERY,
    variables: { id },
  });

  return getSingleProp<Result>(result.data);
};
